import { render, staticRenderFns } from "./SetOfGiftsDropdown.vue?vue&type=template&id=7d1ebdac&lang=pug"
import script from "./SetOfGiftsDropdown.vue?vue&type=script&lang=js"
export * from "./SetOfGiftsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports